<template>
  <span style="cursor:pointer;" @click="openMyAvatarModal()"><button class="btn btn-warning btn-sm">상세</button></span>

  <div class="modal fade" tabindex="-1" :id="'Modal' + TbtnId" v-if="active">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="editModalLabel">사용자 아이템 상세</h5>
        </div>
        <div class="modal-body">
          <table class="table">
            <tbody>
              <tr>
                <th>이름</th>
                <td style="text-align:center;">{{Tsub.name}}</td>
                <th>아이디</th>
                <td style="text-align:center;">{{Tsub.username}}</td>
                <th>성별</th>
                <td style="text-align:center;">{{Tsub.gender}}</td>
              </tr>
              <tr>
                <th>등급</th>
                <td style="text-align:center;">{{Tsub.Tier}}</td>
                <th>알파점수</th>
                <td style="text-align:center;">{{Tsub.t_beta}}</td>
                <th>보물상자</th>
                <td style="text-align:center;">{{Tsub.nextBoxOpen}}</td>
              </tr>
              <tr>
                <th>헤어</th>
                <td>
                  <img v-if="Tsub.detail.hair && Tsub.detail.hair.inteCode" :src="'https://avatar.useschool.co.kr/avatar/img/item/hair/' + Tsub.detail.hair.inteCode + '.png'" style="width:80%">
                  <span v-else>헤어 없음</span>
                </td>
                <th>옷</th>
                <td>
                  <img v-if="Tsub.detail.clothes && Tsub.detail.clothes.inteCode" :src="'https://avatar.useschool.co.kr/avatar/img/item/clothes/' + Tsub.detail.clothes.inteCode + '.png'" style="width:80%">
                  <span v-else>옷 없음</span>
                </td>
                <td rowspan="3" colspan="2">
                  <!-- Vue 메서드로 loadAvatarHere 호출 -->
                  <img :src="avatarSrc" @load="loadAvatarHere" id="my_avatar_img" alt="아바타" style="width:100%;border:solid 1px #6c757d;">
                </td>
              </tr>
              <tr>
                <th>액세서리</th>
                <td>
                  <img v-if="Tsub.detail.weapon && Tsub.detail.weapon.inteCode" :src="'https://avatar.useschool.co.kr/avatar/img/item/weapon/' + Tsub.detail.weapon.inteCode + '.png'" style="width:80%">
                  <span v-else>액세서리 없음</span>
                </td>
                <th>신발</th>
                <td>
                  <img v-if="Tsub.detail.shoes && Tsub.detail.shoes.inteCode" :src="'https://avatar.useschool.co.kr/avatar/img/item/shoes/' + Tsub.detail.shoes.inteCode + '.png'" style="width:80%">
                  <span v-else>신발 없음</span>
                </td>
              </tr>
              <tr>
                <th>펫</th>
                <td>
                  <img v-if="Tsub.detail.pet && Tsub.detail.pet.inteCode" :src="'https://avatar.useschool.co.kr/avatar/img/item/pet/' + Tsub.detail.pet.inteCode + '.png'" style="width:80%">
                  <span v-else>펫 없음</span>
                </td>
                <th>얼굴</th>
                <td>
                  <img v-if="Tsub.detail.face && Tsub.detail.face.inteCode" :src="'https://avatar.useschool.co.kr/avatar/img/item/face/' + Tsub.detail.face.inteCode + '.png'" style="width:80%">
                  <span v-else>얼굴 없음</span>
                </td>
              </tr>
            </tbody>
          </table>
          <div class="flex_center">
            <button type="button" class="btn btn-danger" @click="doSend()">아이템 착용해제</button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: "MyAvatar",
  props: {
    MyAvatar: {
      type: Object,
      default: () => ({})
    },
    btnId: String
  },
  data() {
    return {
      TbtnId: this.btnId || Math.random().toString().substr(2, 5),
      creating: false,
      active: false,
      avatarSrc: 'https://study.useschool.co.kr/img/main/sample_avatar.png', // 기본 아바타 이미지
      Tsub: {
        name: "",
        username: "",
        id: "",
        gender: "",
        hair: "",
        clothes: "",
        weapon: "",
        shoes: "",
        pet: "",
        face: "",
        nextBoxOpen: ""
      },
      changedData: {}
    };
  },
  methods: {
    nvl(str, altStr) {
      if (typeof str === "undefined" || str === null) str = altStr;
      return str;
    },
    openMyAvatarModal() {
      this.active = true;
      this.modifyMode(this.MyAvatar);
      this.$nextTick(function () {
        var modalDom = document.getElementById("Modal" + this.TbtnId);
        var modal = bootstrap.Modal.getOrCreateInstance(modalDom);
        modalDom.addEventListener('hidden.bs.modal', (event) => {
          this.active = false;
        });
        modal.show();
      });
    },
    modifyMode(record) {
      this.creating = false;
      this.changedData = {};
      this.Tsub = { ...record };
    },
    // loadAvatarHere를 Vue의 메서드로 추가
    loadAvatarHere() {
      const img = document.getElementById("my_avatar_img");

      if (img.src.startsWith("blob")) {
        window.URL.revokeObjectURL(img.src);
      }

      const loadImage = (url) => {
        return new Promise((resolve, reject) => {
          const image = new Image();
          image.crossOrigin = "Anonymous";
          image.onload = () => resolve(image);
          image.onerror = () => resolve(null);
          image.src = url;
        });
      };

      const promises = [];

      if (this.Tsub.gender === "F") {
        promises.push(loadImage("https://avatar.useschool.co.kr/avatar/img/girl.png"));
      } else {
        promises.push(loadImage("https://avatar.useschool.co.kr/avatar/img/boy.png"));
      }

      if (this.Tsub.detail.face && this.Tsub.detail.face.inteCode) promises.push(loadImage("https://avatar.useschool.co.kr/avatar/img_2/avatarshop-main/face/" + this.Tsub.detail.face.inteCode));
      if (this.Tsub.detail.hair && this.Tsub.detail.hair.inteCode) promises.push(loadImage("https://avatar.useschool.co.kr/avatar/img_2/avatarshop-main/hair/" + this.Tsub.detail.hair.inteCode));
      if (this.Tsub.detail.clothes && this.Tsub.detail.clothes.inteCode) promises.push(loadImage("https://avatar.useschool.co.kr/avatar/img_2/avatarshop-main/clothes/" + this.Tsub.detail.clothes.inteCode));
      if (this.Tsub.detail.shoes && this.Tsub.detail.shoes.inteCode) promises.push(loadImage("https://avatar.useschool.co.kr/avatar/img_2/avatarshop-main/shoes/" + this.Tsub.detail.shoes.inteCode));
      if (this.Tsub.detail.weapon && this.Tsub.detail.weapon.inteCode) promises.push(loadImage("https://avatar.useschool.co.kr/avatar/img_2/avatarshop-main/weapon/" + this.Tsub.detail.weapon.inteCode));
      if (this.Tsub.detail.pet && this.Tsub.detail.pet.inteCode) promises.push(loadImage("https://avatar.useschool.co.kr/avatar/img_2/avatarshop-main/pet/" + this.Tsub.detail.pet.inteCode));

      Promise.all(promises).then((results) => {
        const canvas = document.createElement('canvas');
        canvas.width = 500;
        canvas.height = 550;

        if (canvas.getContext) {
          const ctx = canvas.getContext("2d");
          results.forEach((image) => {
            if (image) {
              ctx.drawImage(image, 0, 0, 500, 550);
            }
          });
        }

        canvas.toBlob((blob) => {
          const blobUrl = URL.createObjectURL(blob);
          this.avatarSrc = blobUrl; // 완성된 아바타를 Vue 데이터 속성에 설정
        });
      });
    },
    doSend() {
      var data = this.changedData;
      var send = {
        method: this.creating ? "post" : "patch",
        url: '/students/eventList/' + this.Tsub.eventNo,
        data: data
      };

      if (!this.active) {
        $.notify({ message: '사용유무를 지정하셔야 합니다.' }, { type: 'danger', z_index: 9999 });
        return;
      }

      if (Object.keys(this.changedData).length) {
        axios(send).then((response) => {
          if (response.data.error) {
            $.notify({ message: '처리할 수 없습니다. ' + response.data.error }, { type: 'danger', z_index: 9999 });
          } else {
            $.notify({ message: '처리되었습니다' }, { type: 'success', z_index: 9999 });
            this.$parent.search();
            (bootstrap.Modal.getInstance(document.getElementById('Modal' + this.TbtnId))).hide();
          }
        });
      }
    }
  },
  mounted() {
    this.Tsub = this.MyAvatar;
  },
  watch: {
    MyAvatar() {
      this.Tsub = this.MyAvatar;
    }
  }
};
</script>
